export const intervals = [
  {
    label: 'Monthly',
    value: 'm'
  },
  {
    label: 'Quarterly',
    value: 'q'
  },
  {
    label: 'Yearly',
    value: 'y'
  },
  {
    label: 'Full archive',
    value: 'a'
  }
]

export const defaultInterval = 'q'
